import PubSub from 'underpub-js';

/**
 * Sitewide
 */
var Sitewide = function() {};

/**
 * Init
 */
Sitewide.prototype.init = function() {
  var self = this;

  self.windowWidth = window.innerWidth;

  this.initEvents();
  this.initFormieFields();
  this.initSitewideAnalyticsEvents();
  
};

/**
 * Init'ing some sitewide analytics events
 */
 Sitewide.prototype.initSitewideAnalyticsEvents = function() {

	const self = this;

	$('body').on('click', 'a[href^="tel:"]', function() {

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'click_to_call',
			event_category: 'engagement'
		});

	});

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function() {
  //
  // Resizing (at the start)
  //
  var windowThrottled = _.throttle(
    function(e) {
      PubSub.publish('resize');

      const currentWindowWidth = window.innerWidth;

      if (self.windowWidth !== currentWindowWidth) {
        self.windowWidth = currentWindowWidth;
        PubSub.publish('resizeWidth');
      }
    },
    0,
    { trailing: false },
  );
  window.addEventListener('resize', windowThrottled, false);

  //
  // Resized Event (at the end)
  //
  var windowResizeDebounce = _.debounce(function(e) {
    PubSub.publish('resized');
  }, 400);
  window.addEventListener('resize', windowResizeDebounce, false);

  //
  // Window scrolling
  //
  var $window = $(window);
  var $html = $('html');
  var $windowHeight = $window.height();

  $window.on('scroll', function(evt) {
    PubSub.publish('scroll', {
      scrollTop: $window.scrollTop(),
      scrollTopPct: $window.scrollTop() / $html.height(),
    });
  });
};

Sitewide.prototype.initFormieFields = function() {
  var self = this;
  var focusInputList = '[data-field-type="single-line-text"] input, [data-field-type="address"] input, .fui-text-input-field input, [data-field-type="email"] input, .fui-input[type="tel"]';

  $(focusInputList).each(function() {
    var $fieldWrapper = $(this).closest('.fui-field');

    if ($(this).val().length > 0) {
      $fieldWrapper.addClass('is-focused');
    }
  });

  $('body').on(
    'focus input',
    focusInputList,
    function() {
      var $fieldWrapper = $(this).closest('.fui-field');

      $fieldWrapper.addClass('is-focused');
    },
  );

  $('body').on(
    'blur',
    focusInputList,
    function() {
      var $fieldWrapper = $(this).closest('.fui-field');

      if (!($(this).val().length > 0)) {
        $fieldWrapper.removeClass('is-focused');
      }
    },
  );

  // move label for autocomplete address
  $('body').on(
    'change',
    '[data-field-type="address"] input',
    function() {
      var addressContainer = $(this).closest('[data-field-type="address"]');
      var addressInputs = addressContainer.find('input');
      addressInputs.closest('.fui-field').addClass('is-focused');
    }
  )
};

export default Sitewide;
